export default __webpack_public_path__ + "static/terminal-presintation_by-6bf90cc3322a7abcce9915a99b3d33be.png";